export default [
    {
        path: '/dynamic-attribution',
        name: 'dynamic-attribution',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Atribuição',
            icon: 'mdi-puzzle-outline',
            breadcrumbs: [
                { text: 'Atribuição dinâmica', disabled: true, href: '/' },
                { text: 'Atribuição', disabled: true, href: '/' },
            ],
        }
    },
]